module.exports = __webpack_public_path__ + "static/img/bg92.057247d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg92.png
// module id = 4JCB
// module chunks = 0